export function inputValidation(prop1: string): boolean {
  return prop1.trim() === "";
}
